import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Orders from "./pages/Orders";
import OrderDetails from "./pages/OrderDetails";
import Admin from "./pages/Admin";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  const token = localStorage.getItem("token");

  if (!token) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<Orders />} />
        <Route path="/order/:id" element={<OrderDetails />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
      <ScrollToTop />
    </BrowserRouter>
  );
}